import { render, staticRenderFns } from "./wf-information-panel-display.vue?vue&type=template&id=6108b8a8&scoped=true&"
import script from "./wf-information-panel-display.vue?vue&type=script&lang=ts&"
export * from "./wf-information-panel-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-information-panel-display.vue?vue&type=style&index=0&id=6108b8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108b8a8",
  null
  
)

export default component.exports